import(/* webpackMode: "eager" */ "/vercel/path1/apps/encyclopedia/src/app/error.tsx");
